import { render } from "./DigestiveDiseasesClinicPage.vue?vue&type=template&id=6c3a616a"
import script from "./DigestiveDiseasesClinicPage.vue?vue&type=script&lang=js"
export * from "./DigestiveDiseasesClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__